<template>
  <div :class="layoutClass">
    <Toast/>
    <div class="p-grid p-jc-center login-box">
      <div :class="boxClass">
        <div class="center-component">
          <h3>Reset Password</h3>
          <span class="p-float-label p-mb-2">
              <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                      <i class="pi pi-globe"></i>
                  </span>
                  <InputText v-model="password" type="password" placeholder="Password"/>
              </div>
          </span>
          <span class="p-float-label p-mb-2">
              <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                      <i class="pi pi-globe"></i>
                  </span>
                  <InputText v-model="confirm_password" type="password" placeholder="Confirm Password"/>
              </div>
          </span>
          <span class="p-float-label p-mb-4">
              <div class="p-inputgroup">
                  <a href="/login">Back to Login</a>
              </div>
          </span>
          <span class="p-float-label">
              <div class="p-inputgroup">
                  <Button :class="btnClass" label="Submit" @click="onClick"/>
              </div>
          </span>
        </div>
      </div>
      <div class="p-col-4 login-box-right remove-on-mobile">
      </div>
    </div>
  </div>

</template>

<script>
  import router from "../router";
  import LoginService from '../services/LoginService';

  export default {
    data() {
      return {
        password: "",
        confirm_password: "",
      };
    },
    methods: {
      onClick() {
        this.loginService.reset_password(this.password, this.confirm_password, this.$route.params.token).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Your password successfully reset!',
              life: 5000
            });
            router.push("/login");
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to reset password!',
              detail: result.data.error,
              life: 5000
            });
          }
        });
      }
    },
    loginService: null,
    created() {
      this.loginService = new LoginService();
    },
    computed: {
      layoutClass() {
        return ['login', {
          'login-dark': this.$store.state.theme === 'dark',
          'login-light': this.$store.state.theme === 'light',
        }];
      },
      boxClass() {
        return ['p-sm-12 p-md-8 p-lg-8 login-box-left', {
          'login-box-dark': this.$store.state.theme === 'dark',
          'login-box-light': this.$store.state.theme === 'light',
        }];
      },
      btnClass() {
        return ['login-button', {
          'p-button-info': this.$store.state.theme === 'dark',
          'p-button-success': this.$store.state.theme === 'light',
        }];
      },
    },

  }
</script>

<style scoped>

</style>
